import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.object.keys";
import _defineProperty from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.28.3@@babel/runtime-corejs2/helpers/esm/defineProperty.js";
import "core-js/modules/es6.function.name";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/home/program/front/git/ams/node_modules/_@babel_runtime-corejs2@7.28.3@@babel/runtime-corejs2/helpers/esm/asyncToGenerator.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import router from "./router";
import store from "./store";
import { Message } from 'element-ui';
import NProgress from 'nprogress'; // progress bar
import 'nprogress/nprogress.css'; // progress bar style
import { getToken } from '@/utils/auth'; // get token from cookie
import getPageTitle from '@/utils/get-page-title';
NProgress.configure({
  showSpinner: false
}); // NProgress Configuration

// function hasPermission(roles, permissionRoles) {
//   if (roles.indexOf('admin') >= 0) return true // admin权限 直接通过
//   if (!permissionRoles) return true
//   return roles.some(role => permissionRoles.indexOf(role) >= 0)
// }

var whiteList = ['/login']; // no redirect whitelist

router.beforeEach(/*#__PURE__*/function () {
  var _ref = _asyncToGenerator(/*#__PURE__*/regeneratorRuntime.mark(function _callee(to, from, next) {
    var hasToken, hasGetUserInfo, userInfo, userMenu, role, account_type, roles, _t;
    return regeneratorRuntime.wrap(function (_context) {
      while (1) switch (_context.prev = _context.next) {
        case 0:
          // start progress bar
          NProgress.start();

          // set page title
          document.title = getPageTitle(to.meta.title);

          // determine whether the user has logged in
          hasToken = getToken();
          if (!hasToken) {
            _context.next = 9;
            break;
          }
          console.log('to.path', to);
          if (!(to.path === '/login')) {
            _context.next = 1;
            break;
          }
          // if is logged in, redirect to the home page
          if (to.query.ticket || to.query.token) {
            next();
          } else {
            next({
              path: '/'
            });
          }
          NProgress.done();
          _context.next = 8;
          break;
        case 1:
          hasGetUserInfo = store.getters.name && store.getters.school_name;
          if (!hasGetUserInfo) {
            _context.next = 2;
            break;
          }
          next();
          _context.next = 8;
          break;
        case 2:
          _context.prev = 2;
          _context.next = 3;
          return store.dispatch('user/getInfo');
        case 3:
          userInfo = _context.sent;
          _context.next = 4;
          return store.dispatch('user/getUserMenu');
        case 4:
          userMenu = _context.sent;
          role = userInfo.role;
          account_type = userInfo.account_type;
          roles = userMenu;
          _context.next = 5;
          return store.dispatch('GenerateRoutes', {
            roles: roles,
            role: role,
            account_type: account_type
          }).then(function () {
            // 生成可访问的路由表
            router.addRoutes(store.getters.addRouters); // 动态添加可访问路由表
            console.log("--------------->", store.getters.addRouters);
            next(_objectSpread({}, to)); // hack方法 确保addRoutes已完成
          });
        case 5:
          next();
          _context.next = 8;
          break;
        case 6:
          _context.prev = 6;
          _t = _context["catch"](2);
          // remove token and go to login page to re-login
          console.log("error:", _t);
          _context.next = 7;
          return store.dispatch('user/resetToken');
        case 7:
          Message.error(_t || 'Has Error');
          next("/login?redirect=".concat(to.fullPath));
          NProgress.done();
        case 8:
          _context.next = 10;
          break;
        case 9:
          /* has no token*/

          if (whiteList.indexOf(to.path) !== -1) {
            // in the free login whitelist, go directly
            next();
          } else {
            // other pages that do not have permission to access are redirected to the login page.
            next("/login?redirect=".concat(to.fullPath));
            NProgress.done();
          }
        case 10:
        case "end":
          return _context.stop();
      }
    }, _callee, null, [[2, 6]]);
  }));
  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
router.afterEach(function () {
  // finish progress bar
  NProgress.done();
});